export default __webpack_public_path__ + "static/13_35-0ed0c83c21b2a4632f37223d554fa241.png";